"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var Login = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '登录';
        _this.code = '300006';
        _this.desc = '登录';
        _this.requestParams = new coupon_1.LoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Login;
}(service_1.BaseService));
exports.Login = Login;
//# sourceMappingURL=login.js.map